<app-kpi-main [count]="(data$ | async)?.count" [title]="config()?.title"
              [subTitle]="(Utils.humanizeNumber(languageService.texts.general.not_available, (data$ | async)?.riskCount)) + ' ' + config()?.subTitle"
              [status]="(data$ | async)?.statusIcon" [tooltip]="config()?.riskScoreTooltip" [isLoading]="isLoading()"
              [isClickable]="config()?.isClickable ?? true"
              (clicked)="config()?.callbackFn?.(config())">
</app-kpi-main>
